<template>
  <section v-if="visible" class="related">
    <div class="head">
      <h3>相关资讯</h3>
      <router-link class="link" to="/articles">全部资讯</router-link>
    </div>
    <p v-if="loading" class="muted">加载文章…</p>
    <ul v-else class="list">
      <li v-for="item in articles" :key="item.id">
        <router-link :to="`/articles/${encodeURIComponent(item.slug)}`">
          {{ item.title }}
        </router-link>
        <span class="meta">
          <template v-if="item.tags">{{ firstTag(item.tags) }} · </template>
          {{ formatTime(item.published_at) }}
        </span>
      </li>
    </ul>
  </section>
</template>

<script>
import { relatedArticles } from '../api/platformService'

export default {
  name: 'RelatedArticles',
  props: {
    cardId: { type: [Number, String], default: null },
    cardIds: { type: Array, default: () => [] },
    keyword: { type: String, default: '' },
    active: { type: Boolean, default: true }
  },
  data() {
    return {
      articles: [],
      loading: false,
      fetched: false
    }
  },
  computed: {
    hasQuery() {
      return Boolean(this.cardId || this.keyword || (this.cardIds && this.cardIds.length))
    },
    visible() {
      return this.active && this.hasQuery && (this.loading || this.articles.length > 0)
    }
  },
  watch: {
    cardId: 'reload',
    keyword: 'reload',
    cardIds: { deep: true, handler: 'reload' },
    active(v) {
      if (v) this.reload()
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    firstTag(raw) {
      return String(raw || '')
        .split(/[,，]/)
        .map((t) => t.trim())
        .filter(Boolean)[0] || ''
    },
    formatTime(iso) {
      if (!iso) return ''
      return String(iso).replace('T', ' ').slice(0, 16)
    },
    async reload() {
      if (!this.active || !this.hasQuery) {
        this.articles = []
        this.fetched = false
        return
      }
      this.loading = true
      try {
        const params = { limit: 6 }
        if (this.cardId) params.card_id = this.cardId
        if (this.keyword) params.q = this.keyword
        if (this.cardIds && this.cardIds.length) params.card_ids = this.cardIds.join(',')
        const data = await relatedArticles(params)
        this.articles = data.articles || []
        this.fetched = true
      } catch (e) {
        this.articles = []
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.related {
  margin-top: 20px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e5e6eb;
  border-radius: 16px;
}
.head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 10px;
}
.head h3 { margin: 0; font-size: 16px; }
.link, a { color: #165dff; text-decoration: none; }
.link:hover, a:hover { text-decoration: underline; }
.muted { color: #86909c; font-size: 13px; margin: 0; }
.list { list-style: none; margin: 0; padding: 0; }
.list li {
  padding: 8px 0;
  border-top: 1px solid #f2f3f5;
  display: grid;
  gap: 2px;
}
.list li:first-child { border-top: 0; }
.meta { color: #86909c; font-size: 12px; }
</style>
